import React, { useContext, useEffect } from 'react'
import { FaFire, FaGamepad, FaStar } from 'react-icons/fa'
import { Link, useNavigate } from 'react-router-dom'
import { DataContext } from '../../Context/DataContext'

const FirstSection = () => {
  const gameData = useContext(DataContext)
  const navigate = useNavigate()

useEffect(() => {
  const loadAOS = async () => {
    const AOS = await import('aos');
    AOS.init({
      duration: 500,
      easing: "ease-out-cubic",
      once: true,
      offset: 100
    });
  };
  loadAOS();
}, []);



  return (
    <section
      className="relative lg:px-8 overflow-hidden bg-gradient-to-br from-[#0f172a] via-[#0a0f1f] to-[#020617]"
    >
      <div className="absolute inset-0">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              "radial-gradient(circle at 20% 40%, rgba(56,189,248,0.15), transparent 40%), radial-gradient(circle at 80% 60%, rgba(59,130,246,0.15), transparent 40%), radial-gradient(circle at 50% 90%, rgba(236,72,153,0.12), transparent 40%)",
          }}
        ></div>
      </div>

      <div
        className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 lg:pt-20 sm:pt-16 pt-10 lg:pb-24 pb-[55px] text-center"
      >
        <div data-aos="zoom-in" data-aos-delay="100" className="inline-flex items-center px-6 cursor-pointer py-2.5 bg-white/5 border border-cyan-400/30 rounded-full text-cyan-300 text-sm font-medium mb-10 backdrop-blur-sm shadow-[0_0_20px_rgba(56,189,248,0.25)] hover:shadow-[0_0_40px_rgba(56,189,248,0.45)] transition">
          <FaGamepad className="w-4 h-4 mr-2 text-cyan-400" />
           Welcome to Game Zone Hub
          <FaFire className="w-4 h-4 ml-2 text-orange-400 animate-pulse" />
        </div>

        <h1 className="text-3xl sm:text-4xl md:text-5xl xl:text-6xl font-extrabold leading-tight text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-400 drop-shadow-[0_0_20px_rgba(59,130,246,0.45)]">
          Play Free <span className="text-white">Online Games</span>
        </h1>

        <p className="mt-6 max-w-3xl mx-auto text-gray-300 sm:text-lg md:text-xl leading-relaxed">
          Looking to <strong>play free online games</strong>? You've found the ultimate gaming destination! 
          Discover a vast collection of instant-play <strong>online games</strong> including racing, action, puzzles, and adventure. 
          Enjoy seamless gaming on any device with no downloads required. Just click and <strong>play free online</strong> today!
        </p>

        {gameData?.length > 0 && (
          <div data-aos="fade-up" data-aos-delay="200" className="sm:mt-14 mt-10 grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-2xl mx-auto">
            <div className="bg-white/5 cursor-pointer backdrop-blur-md p-6 rounded-2xl border border-white/10 hover:border-cyan-400/40 shadow-lg hover:shadow-[0_0_30px_rgba(56,189,248,0.35)] transition">
              <div className="xl:text-4xl lg:text-3xl md:text-3xl sm:text-2xl text-xl font-bold text-white">
                {gameData?.length - 1}+
              </div>
              <div className="mt-1 text-sm tracking-wide text-gray-400 uppercase">
                Games Available
              </div>
            </div>

            <div className="bg-white/5 cursor-pointer backdrop-blur-md p-6 rounded-2xl border border-white/10 hover:border-yellow-400/40 shadow-lg hover:shadow-[0_0_30px_rgba(250,204,21,0.35)] transition">
              <div className="flex items-center justify-center xl:text-4xl lg:text-3xl md:text-3xl sm:text-2xl text-xl font-bold text-white">
                100%
                <FaStar className="ml-2 text-yellow-400 w-7 h-7 drop-shadow-[0_0_10px_rgba(250,204,21,0.6)]" />
              </div>
              <div className="mt-1 text-sm tracking-wide text-gray-400 uppercase">
                Free to Play
              </div>
            </div>
          </div>
        )}

        <div data-aos="fade-up" data-aos-delay="100" className="mt-12 flex flex-wrap justify-center gap-4">
          <Link
            to="/games"
            className="px-6 py-3 rounded-xl bg-gradient-to-r from-cyan-500 to-blue-500 text-white font-semibold shadow-lg hover:shadow-[0_0_30px_rgba(56,189,248,0.5)] transition"
          >
            Play Free Online Games
          </Link>
          <button
            to="/games"
            className="px-6 py-3 rounded-xl bg-white/10 border border-white/20 text-gray-200 font-medium hover:border-cyan-400/40 hover:text-white transition"
          >
            Browse All Online Games
          </button>
        </div>

        <div className="md:mt-16 mt-11 border-t border-white/10 pt-10 max-w-4xl mx-auto text-center" data-aos="fade-up">
            <h2 className="text-2xl font-bold text-white mb-4">Why Play on Game Zone?</h2>
            <p className="text-gray-400 text-sm leading-7">
                Game Zone provides the best <strong>HTML5 games</strong> experience completely free. 
                Whether you want to play fast-paced car racing, mind-bending strategy puzzles, or casual arcade fun, we have it all. 
                Our platform is optimized for performance, ensuring you can play smoothly on your iPhone, Android, Tablet, or PC without any lag. 
                New games are added regularly to keep the entertainment going. Start to <strong>play free online games</strong> now!
            </p>
        </div>
      </div>
    </section>
  )
}

export default FirstSection
 